import { FormField } from 'ui/formField';
import { RadioGroup } from 'ui/radioGroup/radioGroup';
import { AUTHENTICATION_OPTIONS } from '../constants';
import { SystemWebhookFormState } from '../types';

export const AuthenticationFormField = ({
  updateWebhook,
  webhook,
}: {
  updateWebhook: (field: string, value: string) => void;
  webhook: SystemWebhookFormState;
}) => {
  return (
    <FormField
      data-test="form-field-webhookAuthentication"
      inputId="webhookAuthentication"
      labelText="Authentication"
    >
      <RadioGroup
        name="webhookAuthentication"
        options={AUTHENTICATION_OPTIONS.map((option) => ({
          ...option,
          id: `webhookAuthentication-${option.value}`,
          name: option.value,
        }))}
        value={webhook.authType}
        onSelect={(value: string) => updateWebhook('authType', value)}
      />
    </FormField>
  );
};
